import { actions } from '../constants/profile';
import * as types from '../../models/action/profile';
import { Log } from 'ng2-logger';

const _logger = Log.create('store-action-profile');

export function getProfileAction(spinnerId: string, spinnerType: 'get' | 'set') {
    return {
        timestamp: Date.now(),
        type: actions.GET_PROFILE,
        spinnerId,
        spinnerType
    };
}

export function setProfileAction(profileData: types.AssignData | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ISetProfile {
    return {
        profileData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_PROFILE
    };
}

export function getTimezones(spinnerId: string, spinnerType: 'get' | 'set') {
    return {
        timestamp: Date.now(),
        type: actions.GET_TIMEZONE,
        spinnerId,
        spinnerType
    };
}

export function setTimezoneAction(timezoneData: types.TimezoneData | null, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        timezoneData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_TIMEZONE
    };
}

export function updateProfileAction(profileData: types.AssignData | null, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ISetProfile {
    return {
        profileData,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.UPDATE_PROFILE
    };
}

export function changePasswordAction(passwordData: types.IChangePasswordAssignData | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IChangePassword {
    return {
        passwordData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.CHANGE_PASSWORD
    };
}

export function changePasswordSetAction(isChangePassword: boolean, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        isChangePassword,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.CHANGE_PASSWORD_SET
    };
}

export function changePasswordQuestionAction(passwordQuestionData: types.IChangePasswordQuestionAssignData | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IChangePasswordQuestion {
    return {
        passwordQuestionData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.CHANGE_PASSWORD_QUESTION
    };
}

export function changePasswordQuestionSetAction(isChangePasswordQuestion: boolean, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        isChangePasswordQuestion,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.CHANGE_PASSWORD_QUESTION_SET
    };
}

export function updateProfilePhotoAction(profilePhoto: string | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IUpdateProfilePhoto {
    return {
        profilePhoto,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.UPDATE_PROFILE_PHOTO_ACTION
    };
}

export function setProfilePhotoAction(profilePhotoData: { isProfilePhotoUpload: boolean | null, profilePhoto: string | null, photoKey: string | null }, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IUpdateProfilePhotoSet {
    return {
        profilePhotoData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.UPDATE_PROFILE_PHOTO_ACTION_SET
    };
}

export function getPreferencesAction(spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: any) => void): types.IGetPreferences {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.USER_PREFERENCES_GET,
        callback
    };
}

export function setPreferencesAction(preferences: types.IPreference[] | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ISetPreferences {
    return {
        preferences,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.USER_PREFERENCES_SET
    };
}

export function addOrUpdatePreferencesAction(preferences: any | null, spinnerId?: string, spinnerType?: 'get' | 'set'): types.ISetPreferences {
    return {
        preferences,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.USER_PREFERENCES_ADDORUPDATE
    };
}

export function getChangeLanguageAction(lang: string, callback?: (value: any) => void, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IGetChangeLanguage {
    return {
        lang,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.USER_GET_LANGUAGE
    };
}

export function setChangeLanguageAction(lang: string, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IGetChangeLanguage {
    return {
        lang,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.USER_SET_LANGUAGE
    };
}

export function setChangeLoginLanguageAction(lang: string, spinnerId?: string, spinnerType?: 'get' | 'set'): types.IGetChangeLanguage {
    return {
        lang,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_LOGIN_USER_CULTURE
    };
}